import React, {useEffect} from "react";
import {useFormContext} from "react-hook-form";
import {ModalSelectionInput} from "../../form-components/ModalSelectionInput";
import {ModalTextAreaInput} from "../../form-components/ModalTextAreaInput";
import {YesNoOptionMap} from "../../domain";
import {TreatmentHoldInput} from "./TreatmentHoldFormModal";
import {TreatmentHoldProviderContactFields} from "./TreatmentHoldProviderContactFields";

type Props = {
    sending: boolean;
};

export function TreatmentHoldConsultationFields({sending}: Props) {
    const {watch, setValue} = useFormContext<TreatmentHoldInput>();
    const requestConsultation = watch("providerRequestForCcsConsultation");

    useEffect(() => {
        if (requestConsultation !== "YES") {
            setValue("reasonForConsultation", null);
            setValue("summaryOfStepsTaken", null);
            setValue("providerContactName", null);
            setValue("providerContactEmail", null);
            setValue("providerContactPhone", null);
        }
    }, [requestConsultation, setValue]);

    return (
        <div className="border-t border-gray-300 mt-4 pt-4">
            <ModalSelectionInput<TreatmentHoldInput>
                options={YesNoOptionMap}
                label="Provider Request for CCS Consultation"
                labelClassName="font-bold"
                disabled={sending}
                field="providerRequestForCcsConsultation"
                optionalRules={{required: "Please select 'CCS Consultation' before submitting"}}
            />
            {requestConsultation === "YES" && (
                <>
                    <ModalTextAreaInput
                        disabled={sending}
                        field="reasonForConsultation"
                        label="Reason for Consultation"
                        labelClassName="font-bold"
                        labelPosition="left"
                        rowsNum={3}
                        maxLength={2048}
                        required
                        showCharacterCount
                        requiredMessage="This field is required."
                    />
                    <ModalTextAreaInput
                        disabled={sending}
                        field="summaryOfStepsTaken"
                        label="Summary of Steps Taken"
                        labelClassName="font-bold"
                        labelPosition="left"
                        rowsNum={3}
                        maxLength={2048}
                        required
                        showCharacterCount
                        requiredMessage="This field is required."
                    />
                    <ModalTextAreaInput
                        disabled={sending}
                        field="comments"
                        label="Comments"
                        labelClassName="font-bold"
                        labelPosition="left"
                        rowsNum={3}
                        maxLength={2048}
                        showCharacterCount
                        required={false}
                    />
                    <TreatmentHoldProviderContactFields sending={sending}/>
                </>
            )}
        </div>
    );
}
